<template>
    <div class="content-container">
        <div class="content">
            <div class="container">
                <div class="row">

                    <!-- Title -->
                    <div class="col-12">
                        <div class="title">
                            <h1>
                              <template v-if="isBookingInStore">{{ $t('bp.DeviceModel.inStoreBookingTitle') }}</template>
                              <template v-else>{{ $t('bp.DeviceModel.title') }}</template>
                            </h1>
                        </div>
                    </div>

                    <!-- Options -->
                    <div class="col-12">
                        <div class="card-list scrollable" v-if="models.length > 0">
                            <div class="selectable-card"
                                 v-for="model in models"
                                 :key="model.id"
                                 @click="selectModel(model)"
                                 :class="{ active: modelIsActive(model) }">
                                <div class="card-body">
                                    <p>
                                        {{ model.title }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <!-- Empty state -->
                        <empty-state
                            v-if="models.length === 0"
                            icon="device-invalid"
                            :title="emptyStateWording"
                            :subtitle="$t('bp.DeviceModel.emptyStateSubTitle')"
                        ></empty-state>

                    </div>
                </div>
            </div>

            <!-- Footer -->
            <footer class="footer fixed-footer">
                <div class="container">
                    <router-link :to="{ name: 'deviceType'}" class="btn btn-outline-secondary back-btn btn-lg"><i class="fa fa-chevron-left text-sm mr-3"></i> {{ $t('bp.backButton') }}</router-link>
                    <router-link :to="{ name: 'deviceColour'}" class="btn btn-lg continue-btn icon-right ml-auto" :class="{'disabled': !modelHasBeenSelected}">{{ $t('bp.nextButton') }} <i class="fa fa-chevron-right ml-3 text-sm"></i></router-link>
                </div>
            </footer>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "DeviceModel",

        mounted() {
            this.checkCanBeOnPage();
        },

        computed: {
            ...mapGetters([
                'activeMakeId',
                'countryCodeSetting',
                'isBookingInStore',
                'makes',
                'modelHasBeenSelected',
                'modelIsActive',
                'models',
                'typeHasBeenSelected'
            ]),

            pageTitle() {
                if (this.isBookingInStore) {
                    return this.$t('bp.DeviceModel.inStoreBookingTitle');
                }

                return this.$t('bp.DeviceModel.title');
            },

            emptyStateWording() {
                if (this.countryCodeSetting === 'US') {
                    for (let i = 0; i < this.makes.length; i++) {
                        if (this.activeMakeId === this.makes[i].id) {
                            return "Apple repair services are coming very soon";
                        }
                    }
                }
                return this.$t('bp.DeviceModel.emptyStateTitle');
            }
        },

        methods: {
            ...mapActions([
                'checkBookingIsComplete',
                'selectModel'
            ]),

            checkCanBeOnPage() {
                this.checkBookingIsComplete().then(() => {
                    if (!this.typeHasBeenSelected) {
                        this.$router.push({name: 'deviceType'});
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>